import { UserContext } from '@zola-helpers/client/dist/es/@types';
import { isDesktopV2 } from '@zola-helpers/client/dist/es/util/responsive';

export const getShouldSkipMarketplaceLP = (userContext: UserContext | null | undefined) => {
  return (
    typeof window !== 'undefined' && isDesktopV2() && userContext?.marketplace_account?.has_inquired
  );
};
